import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { PackageMessage } from '@/model/Logistic/PackageMessage';
import { PACKAGE_STATES } from '@/model/Logistic/PackageStates';
import { Shipment } from '@/model/Logistic/Shipment/Shipment';
import { ShippingLabel } from '@/model/Logistic/ShippingLabel/ShippingLabel';
import { RESOURCES } from '@/Resources';

// FIXME unificar repositorios de shipment y reception que hacen lo mismo
class ShipmentApi {
  axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  createAddress = async (addressData: ShippingLabel) => {
    try {
      const response = await this.axiosInstance.post('/shipping_labels', addressData);

      return response.data;
    } catch (error) {
      console.error('Error creating address:', error);
      throw error;
    }
  };

  async printShippingLabel(shipmentId: number) {
    try {
      const config: AxiosRequestConfig = {
        responseType: 'blob',
      };
      const response = await this.axiosInstance.get(
        `${RESOURCES.SHIPMENTS}/${shipmentId}/shipping_label`,
        config,
      );
      const { headers, data } = response;
      const fileName = headers['content-disposition'].split('filename=')[1];
      const type = headers['content-type'];
      const url = window.URL.createObjectURL(new Blob([data], { type: type }));
      const a = document.createElement('a'); // Creamos un botón para simular el click de descarga

      a.href = url;
      a.setAttribute('download', fileName);
      a.click();

      // Se limpia la memoria
      setTimeout(function () {
        window.URL.revokeObjectURL(url);
      }, 1000);

      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  async updateShipmentState(shipmentId: number, newState: PACKAGE_STATES) {
    try {
      const response = await this.axiosInstance.patch(`/shipments/${shipmentId}`, {
        status: newState,
      });

      return response.data;
    } catch (error) {
      console.error('Error updating shipment state:', error);
      throw error;
    }
  }

  async updateShipmentTrackingNumber(shipmentId: number, trackingNumber: string) {
    try {
      const response = await this.axiosInstance.patch(`/shipments/${shipmentId}`, {
        tracking_number: trackingNumber,
      });

      return response.data;
    } catch (error) {
      console.error('Error updating shipment tracking number:', error);
      throw error;
    }
  }

  async updateShipmentExternalDocument(shipmentId: number, externalDocument: string) {
    try {
      const response = await this.axiosInstance.patch(`/shipments/${shipmentId}`, {
        external_document: externalDocument,
      });

      return response.data;
    } catch (error) {
      console.error('Error updating shipment external document:', error);
      throw error;
    }
  }

  async updateShipment(shipmentId: number, shipmentData: Partial<Shipment>) {
    try {
      const response = await this.axiosInstance.patch(`/shipments/${shipmentId}`, {
        ...shipmentData,
      });

      return response.data;
    } catch (error) {
      console.error('Error updating shipment external document:', error);
      throw error;
    }
  }

  async getMessages(shipmentId: number) {
    try {
      const response = await this.axiosInstance.get(`/messages`, {
        params: { package: shipmentId },
      });

      return response.data;
    } catch (error) {
      console.error('Error fetching shipment messages:', error);
      throw error;
    }
  }

  async postMessage(shipmentId: number, message: PackageMessage) {
    try {
      const response = await this.axiosInstance.post(`/messages`, {
        ...message,
        destination_users: message.destination_users_data,
      });

      return response.data;
    } catch (error) {
      console.error('Error posting shipment message:', error);
      throw error;
    }
  }
}

export default ShipmentApi;
